import { IconSet } from "../icon/icon.props";
import { JustifyContent } from "../justify-content";

enum ButtonDataBsToggle {
    button = 'button',
    dropdown = 'dropdown',    
    collapse = 'collapse',
    offcanvas = 'offcanvas',
    tooltip = 'tooltip'
}

enum ButtonDataBsPlacement {
    top = 'top',
    right = 'right',
    left = 'left',
    bottom = 'bottom'
}

enum ButtonSize {
    Small = 'Small',
    Medium = 'Medium',
    Large = 'Large'
}

enum ButtonType {
    Button = "Button",
    Submit = "Submit",
    Reset = "Reset",
    Menu = "Menu"
}

enum ButtonVariant {
    Cta = 'Cta',
    Secondary = 'Secondary',
    Action = 'Action',
    Destructive = 'Destructive',
    DestructiveAction = 'DestructiveAction',
    Light = 'Light'
}

export {
    ButtonDataBsToggle,
    ButtonDataBsPlacement,
    ButtonSize,
    ButtonType,
    ButtonVariant,
    IconSet,
    JustifyContent
};
